/**
 * Shopify Storefront API Client
 * Core GraphQL client for all Shopify Storefront API operations
 */

class ShopifyStorefrontAPI {
  constructor(config) {
    this.shopDomain = config.shopDomain;
    this.storefrontAccessToken = config.storefrontAccessToken;
    this.apiVersion = config.apiVersion || '2025-10';
    this.endpoint = `https://${this.shopDomain}/api/${this.apiVersion}/graphql.json`;
  }

  /**
   * Execute GraphQL query or mutation
   * @param {string} query - GraphQL query/mutation string
   * @param {Object} variables - Variables for the query
   * @param {string} customerAccessToken - Optional customer access token
   * @returns {Promise<Object>}
   */
  async request(query, variables = {}, customerAccessToken = null) {
    const headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken
    };

    // Add customer access token if provided
    if (customerAccessToken) {
      headers['X-Customer-Access-Token'] = customerAccessToken;
    }

    try {
      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          query: query,
          variables: variables
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Check for GraphQL errors
      if (data.errors) {
        throw new Error(JSON.stringify(data.errors));
      }

      return data;
    } catch (error) {
      console.error('Shopify Storefront API Error:', error);
      throw error;
    }
  }

  /**
   * Execute GraphQL mutation
   * @param {string} mutation - GraphQL mutation string
   * @param {Object} variables - Variables for the mutation
   * @param {string} customerAccessToken - Optional customer access token
   * @returns {Promise<Object>}
   */
  async mutate(mutation, variables = {}, customerAccessToken = null) {
    return this.request(mutation, variables, customerAccessToken);
  }

  /**
   * Execute GraphQL query
   * @param {string} query - GraphQL query string
   * @param {Object} variables - Variables for the query
   * @param {string} customerAccessToken - Optional customer access token
   * @returns {Promise<Object>}
   */
  async query(query, variables = {}, customerAccessToken = null) {
    return this.request(query, variables, customerAccessToken);
  }
}

// Export for use in other modules
if (typeof window !== 'undefined') {
  window.ShopifyStorefrontAPI = ShopifyStorefrontAPI;
}




